module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-box"
  }, [_c('b', {
    staticClass: "title-identification"
  }, [_vm._v("Informações básicas")]), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-group margin-b30 input-box-control",
    class: {
      'has-error': _vm.errors.has('taxIdNumber')
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.user.taxIdNumberFormatted),
      expression: "user.taxIdNumberFormatted",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|cpf|accountExists:cpf'),
      expression: "'required|cpf|accountExists:cpf'"
    }, {
      name: "mask-cpf",
      rawName: "v-mask-cpf"
    }],
    ref: "taxIdNumber",
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "id": "taxIdNumber",
      "name": "taxIdNumber",
      "title": "cpf",
      "maxlength": "11",
      "readonly": _vm.blockTaxIdNumber,
      "spellcheck": "false",
      "autocomplete": "off",
      "autocorrect": "off",
      "autocapitalize": "off",
      "data-vv-validate-on": "blur",
      "placeholder": "000.000.000-00"
    },
    domProps: {
      "value": (_vm.user.taxIdNumberFormatted)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.user, "taxIdNumberFormatted", $event.target.value)
      }, function($event) {
        return _vm.ValidacaoNetrim()
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("taxIdNumber")) + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group input-box-control margin-b30",
    class: {
      'has-error': _vm.errors.has('birthDate')
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.user.person.birthDateBR),
      expression: "user.person.birthDateBR",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|older|min:10'),
      expression: "'required|older|min:10'"
    }, {
      name: "mask-birth",
      rawName: "v-mask-birth"
    }],
    ref: "birthDate",
    staticClass: "form-control small",
    attrs: {
      "name": "birthDate",
      "type": "text",
      "title": "data de nascimento",
      "placeholder": "00/00/0000"
    },
    domProps: {
      "value": (_vm.user.person.birthDateBR)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.user.person, "birthDateBR", $event.target.value)
      }, function($event) {
        return _vm.ValidacaoNetrim()
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("birthDate")) + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b30 input-box-control",
    class: {
      'has-error': _vm.errors.has('nome')
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.person.fullName),
      expression: "user.person.fullName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|complete-name'),
      expression: "'required|complete-name'"
    }],
    staticClass: "form-control small",
    attrs: {
      "name": "nome",
      "type": "text",
      "title": "nome",
      "spellcheck": "false",
      "autocomplete": "off",
      "autocorrect": "off",
      "autocapitalize": "off",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.user.person.fullName)
    },
    on: {
      "change": function($event) {
        return _vm.ValidacaoNetrim()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.person, "fullName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("nome")) + "\n              ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-box"
  }, [_c('b', {
    staticClass: "title-identification"
  }, [_vm._v("Contatos")]), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-group margin-b30 input-box-control",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.accountAuthentication.login),
      expression: "user.accountAuthentication.login"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control small",
    attrs: {
      "disabled": !this.validacao,
      "type": "text",
      "id": "email",
      "name": "email",
      "title": "email",
      "placeholder": "Ex: nome@empresa.com.br"
    },
    domProps: {
      "value": (_vm.user.accountAuthentication.login)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.accountAuthentication, "login", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("email")) + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b30 input-box-control",
    class: {
      'has-error': _vm.errors.has('celular')
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cel),
      expression: "cel"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|cell'),
      expression: "'required|cell'"
    }],
    staticClass: "form-control small",
    attrs: {
      "disabled": !this.validacao,
      "type": "text",
      "id": "celular",
      "name": "celular",
      "title": "celular",
      "placeholder": "00-00000-0000",
      "data-vv-validate-on": "blur",
      "maxlength": "14"
    },
    domProps: {
      "value": (_vm.cel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cel = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("celular")) + "\n              ")])]), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group input-box-control margin-b30",
    class: {
      'has-error': _vm.errors.has('telefone')
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tel),
      expression: "tel"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('phone'),
      expression: "'phone'"
    }],
    staticClass: "form-control small",
    attrs: {
      "disabled": !this.validacao,
      "type": "text",
      "id": "telefone",
      "name": "telefone",
      "title": "telefone",
      "placeholder": "00-0000-0000",
      "data-vv-validate-on": "blur",
      "maxlength": "13"
    },
    domProps: {
      "value": (_vm.tel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tel = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("telefone")) + "\n              ")])]), _vm._v(" "), _vm._t("default")], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-box"
  }, [_c('b', {
    staticClass: "title-identification margin-b10"
  }, [_vm._v("Segurança")]), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group margin-b30 input-box-control margin-pass",
    class: {
      'has-error': _vm.errors.has('password')
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.accountAuthentication.password),
      expression: "user.accountAuthentication.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:8|max:20|moveMaisCPF'),
      expression: "'required|min:8|max:20|moveMaisCPF'"
    }],
    staticClass: "form-control small",
    attrs: {
      "disabled": !this.validacao,
      "type": "password",
      "id": "password",
      "name": "password",
      "title": "senha",
      "maxlength": "20",
      "data-vv-validate-on": "blur"
    },
    domProps: {
      "value": (_vm.user.accountAuthentication.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.accountAuthentication, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("password")) + "\n                  ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group margin-b30 input-box-control",
    class: {
      'has-error': _vm.errors.has('confirm-password')
    }
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.accountAuthentication.confirmPassword),
      expression: "user.accountAuthentication.confirmPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (
        'required|min:8|max:20|confirmed:password|moveMaisCPF'
      ),
      expression: "\n                      'required|min:8|max:20|confirmed:password|moveMaisCPF'\n                    "
    }],
    staticClass: "form-control small",
    attrs: {
      "disabled": !this.validacao,
      "type": "password",
      "id": "confirm-password",
      "name": "confirm-password",
      "title": "confirmar senha",
      "maxlength": "20",
      "data-vv-validate-on": "blur"
    },
    domProps: {
      "value": (_vm.user.accountAuthentication.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.accountAuthentication, "confirmPassword", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("confirm-password")) + "\n                  ")])])])])]), _vm._v(" "), _vm._m(8)])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-box"
  }, [_c('address-comp', {
    ref: "addressMailing",
    attrs: {
      "address": _vm.address,
      "type": "MAILING"
    }
  })], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("CPF:*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Data de nascimento:*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Nome Completo:*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("E-mail:*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Tel .Celular:*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Tel. Residencial:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Senha:*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Confirme a Senha:*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-dicas"
  }, [_vm._v("Senha deve ter de 8 a 20 caracteres")]), _vm._v(" "), _c('div', {
    staticClass: "box-dicas"
  }, [_vm._v("Senha deve ter pelo menos um número")]), _vm._v(" "), _c('div', {
    staticClass: "box-dicas"
  }, [_vm._v("Senha deve ter uma letra maiúscula")]), _vm._v(" "), _c('div', {
    staticClass: "box-dicas"
  }, [_vm._v("Senha deve ter um caractere especial")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-2483f03d!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/adhesion/user-data.vue
// module id = 2067
// module chunks = 1